import css from "./index.module.css";

/**
 * custom loading spinner to give the user feedback that something is loading
 * @returns simple loading spinner animation
 */
const Loading = () => {

  return (
    <div className={css.container}>
      <div className={css.spinner}></div>
    </div>
  )

}

export default Loading;